export const tableColumns1 = (ctx) => {
  return [
    {
      name: '反馈主题',
      prop: 'title',
      type: 'input',
      span: 12,
      maxlength: 20,
    },
    {
      name: '反馈人',
      prop: 'feedbackPersonName',
      type: 'input',
      span: 12,
      maxlength: 20,
    },
    {
      name: '反馈时间',
      prop: 'feedbackDate',
      type: 'startDaterangePickerTime',
      span: 12,
    },
    {
      name: '联系方式',
      prop: 'contactWay',
      type: 'input',
      span: 12,
      maxlength: 20,
    },
    {
      name: '反馈内容',
      prop: 'feedbackContent',
      type: 'textarea',
      span: 24,
      maxlength: 500,
    },
    {
      name: '处理状态',
      prop: 'processStatus',
      type: 'select',
      options: [
        { value: '1', label: '待处理' },
        { value: '2', label: '已处理' },
      ],
      span: 12,
      isHidden: ctx.pageMode != 1,
    },
    {
      name: '创建人',
      prop: 'createPersonName',
      type: 'input',
      span: 12,
      isHidden: ctx.pageMode != 1,
    },
    {
      name: '创建时间',
      prop: 'gmtCreateShow',
      type: 'startDaterangePickerTime',
      span: 12,
      isHidden: ctx.pageMode != 1,
    },
  ];
};
export const tableColumns2 = (ctx) => {
  return [
    {
      name: '处理方案',
      prop: 'processPlan',
      type: 'textarea',
      span: 24,
      maxlength: 500,
    },
    {
      name: '处理人',
      prop: 'processPersonNo',
      type: 'searchTableSpec',
      searchType: 'personnel',
      extraData: {
        adminFlag: ctx.userInfo.adminFlag,
        dataStatus: 'ZT03',
        personCompanyCode: ctx.userInfo.companyCode,
        // personDepartmentCode:ctx.userInfo.departmentCode
      },
      changeMethod: 'changeMethod',
      currentValue: ctx.baseInfoData2.processPersonName,
      isMultiple: true,
      span: 12,
    },
    {
      name: '处理时间',
      prop: 'processDateShow',
      type: 'startDaterangePickerTime',
      span: 12,
    },
  ];
};
